const csvCell = (value: unknown): string => {
  const text = String(value ?? "");
  const safe =
    typeof value !== "number" && /^[=+\-@]/.test(text) ? `'${text}` : text;

  return `"${safe.replace(/"/g, '""')}"`;
};

export function downloadCsv(
  filename: string,
  header: string[],
  rows: unknown[][],
): void {
  const csv = [header, ...rows]
    .map((values) => values.map(csvCell).join(","))
    .join("\r\n");
  const url = URL.createObjectURL(
    new Blob(["\uFEFF", csv], { type: "text/csv;charset=utf-8" }),
  );
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.hidden = true;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
